import React, { FunctionComponent } from 'react';

import { IconsProps } from './Icons.type';

export const PeopleIcon: FunctionComponent<IconsProps> = (props) => (
    <svg
        width="20"
        height="22"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.125 14.25C16.125 14.25 17 14.25 17 13.375C17 12.5 16.125 9.875 12.625 9.875C9.125 9.875 8.25 12.5 8.25 13.375C8.25 14.25 9.125 14.25 9.125 14.25H16.125ZM9.14455 13.375C9.14152 13.3747 9.13728 13.3741 9.13213 13.3732C9.12971 13.3728 9.12733 13.3724 9.12501 13.372C9.12628 13.1409 9.27101 12.471 9.78935 11.8663C10.2742 11.3007 11.1223 10.75 12.625 10.75C14.1277 10.75 14.9758 11.3007 15.4607 11.8663C15.979 12.471 16.1237 13.1409 16.125 13.372C16.1227 13.3724 16.1203 13.3728 16.1179 13.3732C16.1127 13.3741 16.1085 13.3747 16.1054 13.375H9.14455Z"
            fill="#27ae60"
        />
        <path
            d="M12.625 8.125C13.5915 8.125 14.375 7.3415 14.375 6.375C14.375 5.4085 13.5915 4.625 12.625 4.625C11.6585 4.625 10.875 5.4085 10.875 6.375C10.875 7.3415 11.6585 8.125 12.625 8.125ZM15.25 6.375C15.25 7.82475 14.0747 9 12.625 9C11.1753 9 10 7.82475 10 6.375C10 4.92525 11.1753 3.75 12.625 3.75C14.0747 3.75 15.25 4.92525 15.25 6.375Z"
            fill="#27ae60"
        />
        <path
            d="M9.06894 10.12C8.74712 10.017 8.38959 9.94219 7.993 9.90392C7.79671 9.88498 7.59085 9.875 7.375 9.875C3.875 9.875 3 12.5 3 13.375C3 13.9583 3.29167 14.25 3.875 14.25H7.56432C7.44112 14.0014 7.375 13.7067 7.375 13.375C7.375 12.491 7.70509 11.5883 8.32859 10.8342C8.54161 10.5765 8.78888 10.3362 9.06894 10.12ZM7.30504 10.7504C6.78224 11.5494 6.5 12.4603 6.5 13.375H3.875C3.875 13.1469 4.01871 12.4737 4.53935 11.8663C5.0166 11.3095 5.84593 10.7672 7.30504 10.7504Z"
            fill="#27ae60"
        />
        <path
            d="M4.3125 6.8125C4.3125 5.36275 5.48775 4.1875 6.9375 4.1875C8.38725 4.1875 9.5625 5.36275 9.5625 6.8125C9.5625 8.26225 8.38725 9.4375 6.9375 9.4375C5.48775 9.4375 4.3125 8.26225 4.3125 6.8125ZM6.9375 5.0625C5.971 5.0625 5.1875 5.846 5.1875 6.8125C5.1875 7.779 5.971 8.5625 6.9375 8.5625C7.904 8.5625 8.6875 7.779 8.6875 6.8125C8.6875 5.846 7.904 5.0625 6.9375 5.0625Z"
            fill="#27ae60"
        />
        <rect
            x="1.3"
            y="1.3"
            width="16.8"
            height="16.8"
            rx="5.7"
            stroke="#27ae60"
            strokeWidth="1.4"
        />
    </svg>
);
